export default __webpack_public_path__ + "static/laguna-4b547c3396fc60d0001ebe76a9c81864.png";